export const initEstarkMap = (maps) => {
    const center = {lat: 33.23, lng: 51.21};
    const site = {lat: 34.02333, lng: 51.23083};
    const map = new maps.Map(document.getElementById('EstarkMap'), {
        zoom: 5,
        center: center
    });

    const markerIcon = {
        url: 'http://image.flaticon.com/icons/svg/252/252025.svg',
        scaledSize: new maps.Size(30, 30),
        origin: new maps.Point(0, 0),
        labelOrigin: new maps.Point(-10, -10)
    };

    new maps.Marker({
        position: site,
        map: map,
        icon: markerIcon,
        label: {
            text: "Estark",
            color: "red",
            fontSize: "24px",
            fontWeight: "bold"
        }
    });
};
